<template>
  <div class="products-page">
    <!-- Hero Section -->
    <div class="products-hero">
      <img src="@/assets/images/Header_product_vue_page.png" alt="Our Products" class="hero-image" />
      <div class="hero-content">
        <div class="container">
          <h1 class="hero-title">
            <div class="hero-subtitle">OUR PRODUCTS</div>
            <div class="hero-main-title">INNOVATIVE SOLUTIONS FOR YOUR BUSINESS NEEDS</div>
          </h1>
        </div>
      </div>
    </div>

    <!-- Products Section -->
    <div class="products-section">
      <div class="container">
        <div class="products-content">
          <div class="products-text">
            <h2 class="cta-heading">Discover How Our Solutions Can Grow Your Business</h2>
            <p>At Advanced Innovatics Solutions, we develop cutting-edge technology products designed to solve real business challenges. Our solutions are built with innovation, reliability, and user experience at their core.</p>
            
            <div class="product-cards">
              <div class="product-card">
                <h3>eID Card Reader</h3>
                <p>Secure and efficient electronic ID card verification solution that reads and validates data directly from the chip of the new Romanian electronic ID cards.</p>
                <ul class="product-features">
                  <li>Quick and secure ID verification</li>
                  <li>Seamless integration with existing systems</li>
                  <li>Compliant with Romanian eID standards</li>
                  <li>User-friendly interface</li>
                </ul>
                <router-link to="/products/id-card" class="btn-apply">View Details</router-link>
              </div>

              <div class="product-card">
                <h3>Coming Soon</h3>
                <p>We're constantly working on new solutions to help businesses thrive in the digital age. Stay tuned for more innovative products coming your way!</p>
                <a href="#" class="btn-apply" style="pointer-events: none; opacity: 0.7;">Coming Soon</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <section class="cta">
      <div class="container">
        <div class="cta-content">
          <div class="cta-content-wrapper">
            <div class="cta-social">
              <div class="social-title">Follow us!</div>
              <div class="social-icons">
                <a href="https://www.linkedin.com/company/advanced-innovatics-solutions" aria-label="LinkedIn" class="social-icon" target="_blank" rel="noopener">
                  <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                </a>
              </div>
            </div>
            
            <div class="cta-main-content">
              <h2>Interested in our products?</h2>
              <router-link to="/contact" class="btn btn-white">Let's connect</router-link>
              
              <div class="cta-quick-links">
                <h3>Quick Links</h3>
                <ul>
                  <li><router-link to="/">Home</router-link></li>
                  <li><router-link to="/services">Services</router-link></li>
                  <li><router-link to="/about">About Us</router-link></li>
                  <li><router-link to="/careers">Careers</router-link></li>
                  <li><router-link to="/contact">Contact</router-link></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div class="cta-footer">
            <p>Copyright &copy; 2025 Advanced Innovatics Solutions | All rights reserved.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ProductsPage',  
  metaInfo: {
    title: 'Our Products - Advanced Innovatics Solutions',
    meta: [
      { name: 'description', content: 'Discover our innovative technology products designed to solve real business challenges and drive digital transformation.' }
    ]
  }
}
</script>

<style scoped>
.products-page {
  padding: 0;
  margin: 0;
  width: 100%;
}

.products-hero {
  position: relative;
  height: 500px;
  overflow: hidden;
  margin-bottom: 4rem;
}

.products-hero .hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  padding-left: 10%;
}

.hero-content .container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.hero-title {
  color: white;
  line-height: 1.2;
  text-align: left;
  max-width: 800px;
  margin: 0;
  padding: 0;
}

.hero-subtitle {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #ffffff;
  opacity: 0.9;
  display: block;
}

.hero-main-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
  max-width: 80%;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@media (max-width: 1200px) {
  .hero-main-title {
    font-size: 3rem;
    max-width: 90%;
  }
}

@media (max-width: 768px) {
  .hero-content {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
    margin-bottom: 1rem;
    letter-spacing: 1px;
  }
  
  .hero-main-title {
    font-size: 2rem;
    max-width: 100%;
  }
}

.products-section {
  padding: 5rem 0;
  background-color: #fff;
}

.products-content {
  text-align: center;
}

.products-text {
  line-height: 1.8;
  color: #2c3e50;
  font-size: 1.1rem;
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
}

.cta-heading {
  font-size: 2.5rem;
  color: #1a237e;
  margin: 0 0 1.5rem 0;
  font-weight: 700;
  line-height: 1.2;
}

.product-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.product-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.product-card h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.product-card p {
  margin-bottom: 1.5rem;
  color: #555;
}

.product-features {
  list-style: none;
  padding: 0;
  margin: 1.5rem 0 0 0;
}

.product-features li {
  position: relative;
  padding-left: 1.8rem;
  margin-bottom: 0.8rem;
  color: #555;
}

.product-features li:before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #42b983;
  font-weight: bold;
}

.btn-apply {
  display: inline-block;
  margin-top: 1.5rem;
  padding: 0.5rem 1.5rem;
  background-color: #4361ee;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn-apply:hover {
  background-color: #3a56d4;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .products-hero {
    height: 400px;
  }

  .products-hero h1 {
    font-size: 2.5rem;
  }

  .products-hero p {
    font-size: 1.2rem;
  }

  .products-section {
    padding: 3rem 0;
  }
  
  .products-content h2 {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  
  .product-cards {
    grid-template-columns: 1fr;
  }
}

/* CTA Section Styles */
.cta {
  background: #1a237e; /* Darker blue background */
  color: white;
  padding: 4rem 0;
  margin-top: 4rem;
  text-align: center;
}

.cta .container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.cta .cta-content {
  text-align: center;
  width: 100%;
}

.cta .cta-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: white;
}

.cta h2 {
  color: white;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
}

.cta p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.cta .btn-white {
  display: inline-block;
  background: transparent;
  color: #ffffff;
  padding: 0.8rem 2.5rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: 3px solid #ffffff;
  margin: 1rem 0 2.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cta .btn-white:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-social {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  margin: 0 0 1.5rem 0;
  padding: 0;
  text-align: left;
}

.cta .cta-social .social-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #ffffff;
}

.cta .cta-social .social-icons {
  display: flex;
  gap: 1rem;
}

.cta .cta-social .social-icon {
  width: 40px;
  height: 40px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.25rem;
  transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.cta .cta-social .social-icon:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-quick-links {
  flex: 0 0 100%;
  margin-top: 1rem;
}

.cta .cta-quick-links h3 {
  margin: 1.5rem 0 0.5rem;
  font-size: 1rem;
  color: #ffffff;
}

.cta .cta-quick-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta .cta-quick-links a {
  color: #ffffff;
  text-decoration: none;
  opacity: 0.9;
}

.cta .cta-quick-links a:hover {
  text-decoration: underline;
  opacity: 1;
}

.cta .cta-footer {
  margin-top: 2rem;
  font-size: 0.9rem;
  opacity: 0.7;
  padding-top: 1.5rem;
  width: 100%;
}

.cta .cta-footer p {
  margin: 0;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .cta .container {
    flex-direction: column;
  }
  
  .cta .cta-content {
    text-align: center;
    width: 100%;
  }
  
  .cta .cta-social {
    justify-content: center;
    margin-bottom: 2rem;
  }
}
</style>